import {
    fetchHydra as baseFetchHydra,
    hydraDataProvider as baseHydraDataProvider
    // useIntrospection,
} from "@api-platform/admin";
import { parseHydraDocumentation } from "@api-platform/api-doc-parser";
import { ENTRYPOINT } from "../config";

const getHeaders = () => {
    if (localStorage.getItem("token")) {
        return {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        };
    }
    return {};
};

export const fetchHydra = (url, options = {}) => {
    let rawResponse;
    
    const headers = {
        ...getHeaders(),
        ...(options.headers || {})
    };
    
    // Ne définir Content-Type que si ce n'est pas un FormData
    // Le navigateur définit automatiquement le bon Content-Type avec boundary pour FormData
    if (!(options.body instanceof FormData)) {
        headers['Content-Type'] = 'application/ld+json';
    }
    
    return fetch(url.toString(), {
        ...options,
        headers,
    })
    .then(response => {
        rawResponse = response;
        return response.json().catch(() => {
            return null;
        });
    })
    .then(json => {
        const finalResponse = {
            json,
            status: rawResponse.status,
            headers: rawResponse.headers,
            linkHeader: rawResponse.headers.get('link')
        };
        
        if (!rawResponse.ok) {
            const error = new Error(json && json['hydra:description'] ? json['hydra:description'] : rawResponse.statusText);
            error.status = rawResponse.status;
            error.body = json;
            error.json = json;
            
            return Promise.reject(error);
        }
        
        return finalResponse;
    });
};

const apiDocumentationParser = async () => {
    try {
        return await parseHydraDocumentation(ENTRYPOINT, { headers: getHeaders });
    } catch (result) {
        const { api, response, status } = result;
        if (status !== 401 || !response) {
            throw result;
        }

        // Prevent infinite loop if the token is expired
        localStorage.removeItem("token");

        return {
            api,
            response,
            status
            // customRoutes: [
            //     <Route key="/" path="/" element={<RedirectToLogin />} />
            // ],
        };
    }
};

const customHttpClient = (url, options = {}) => {
    return fetchHydra(url, options);
};

export const dataProvider = baseHydraDataProvider({
    entrypoint: ENTRYPOINT,
    httpClient: customHttpClient,
    apiDocumentationParser
});

export const dataProviderWithLinkHeader = {
    ...dataProvider,
    getList: (resource, params) => {
        return dataProvider.getList(resource, params).then(response => {
            if (response.rawHttpResponse && response.rawHttpResponse.linkHeader) {
                response.linkHeader = response.rawHttpResponse.linkHeader;
            }
            return response;
        });
    }
};
